export default __webpack_public_path__ + "static/N0093-dba4a63177d06378564fd1918416b01d.png";